
import Layout from "antd/es/layout";
import HeaderNav from "../components/HeaderNav/HeaderNav";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { ROUTES } from "utils/constants";
import Login from "pages/Diagnostics/Auth/Login/Login";
import DiagnosticSideNav from "pages/Diagnostics/DiagnosticsSideNav/DiagnosticSideNav";
import { DiagnosticsAuthProvider, useDiagnosticsAuth } from "pages/Diagnostics/context/DiagnosticsAuthContext";
import { useState } from "react";
import Home from "pages/Diagnostics/Home/Home";

const { Content } = Layout;

function Diagnostics() {
  return (
    <DiagnosticsAuthProvider>
      <DiagnosticsInner />
    </DiagnosticsAuthProvider>
  );
}

function DiagnosticsInner() {
  const { isAuthenticated, token } = useDiagnosticsAuth();
  const location = useLocation();


  // Redirect authenticated users away from login page
  if (isAuthenticated && location.pathname === ROUTES.DIAGNOSTICS_LOGIN) {
    return <Navigate to={ROUTES.DIAGNOSTICS_HOME} replace />;
  }

  // If not authenticated and not on diagnostics login, redirect to diagnostics login
  if (!isAuthenticated && location.pathname !== ROUTES.DIAGNOSTICS_LOGIN) {
    return <Navigate to={ROUTES.DIAGNOSTICS_LOGIN} replace />;
  }

  return (
    <Layout style={{ height: "100vh" }}>
      <HeaderNav></HeaderNav>
      <Layout
        className="site-layout"
        style={{ height: "100%", overflow: "hidden" }}
      >
        {isAuthenticated && <DiagnosticSideNav />}
        <Content
          style={{ padding: 0, overflowY: "auto", overflowX: "hidden" }}
          className="px-sm-3 p-1 py-2"
        >
          <Routes>
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={"/home"} element={<Home />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default Diagnostics; 